import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from '../contexts/I18n';
import "./Services.css";

const towns = [
  "Maadi",
  "Masr El Gedida",
  "Heliopolis",
  "Nasr City",
  "New Cairo",
  "October City",
  "Zamalek",
  "Mohandessin",
  "Dokki",
  "Giza",
];

const Services = () => {
  const { t, lang } = useI18n();
  // Split towns into two rows
  const firstRow = towns.slice(0, Math.ceil(towns.length / 2));
  const secondRow = towns.slice(Math.ceil(towns.length / 2));

  const content = (
    <div className="rows-container">
      <div className="towns-row">
        {firstRow.map((town, index) => (
          <div key={index} className="town-card">
            <Link to={`/town/${town.toLowerCase().replace(/\s+/g, "-")}`}>
              <button className="town-btn">{town}</button>
            </Link>
          </div>
        ))}
      </div>
      <div className="towns-row">
        {secondRow.map((town, index) => (
          <div key={index} className="town-card">
            <Link to={`/town/${town.toLowerCase().replace(/\s+/g, "-")}`}>
              <button className="town-btn">{town}</button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="towns-container" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <h1 className="towns-title">{t('whereToExpectShops')}</h1>
      {content}
    </div>
  );
};

export default Services;
